/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&setup=true&name=Footer&lang=js"
export * from "./index.vue?vue&type=script&setup=true&name=Footer&lang=js"

import "./index.vue?vue&type=style&index=0&id=326f0958&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-326f0958"]])

export default __exports__